// Invoicing
// API related actions
export const CREATING_LUBRICANTS_INVOICE = '@@toyota/CREATING_LUBRICANTS_INVOICE';
export const CREATED_LUBRICANTS_INVOICE = '@@toyota/CREATED_LUBRICANTS_INVOICE';
export const CREATED_LUBRICANTS_INVOICE_FAILED = '@@toyota/CREATED_LUBRICANTS_INVOICE_FAILED';

// Complementary actions
export const CLEAR_LUBRICANTS_INFO = '@@toyota/CLEAR_LUBRICANTS_INFO';
export const SELECT_ALL_ITEMS = '@@toyota/SELECT_ALL_ITEMS';
export const CHANGE_SEQUENCES_MARKED = '@@toyota/CHANGE_SEQUENCES_MARKED';
